"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localLogger = exports.SearchPreviewProductContainer = void 0;
var _mui = require("@ori-ui/mui");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../../components");
var _constantsGenerated = require("../../constants-generated");
var _contexts = require("../../contexts");
var _logger2 = require("../../logger");
var _Translations = require("../Translations");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve --container */

const localLogger = exports.localLogger = _logger2.mainLogger.createChild('SearchPreviewProduct');
const SearchPreviewProductContainer = ({
  translations,
  withTranslationsProvider,
  responsive = true,
  ...props
}) => {
  const theme = (0, _react.useMemo)(() => (0, _mui.createTheme)({
    responsiveLayout: responsive
  }), [responsive]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      logger: localLogger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Presentation,
        project: _constantsGenerated.APP_NAME,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Translations.Translations, {
          translations: translations,
          withTranslationsProvider: withTranslationsProvider,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.SearchPreviewProductProvider, {
            value: props,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SearchPreviewProduct, {})
          })
        })
      })
    })
  });
};
exports.SearchPreviewProductContainer = SearchPreviewProductContainer;
//# sourceMappingURL=SearchPreviewProductContainer.js.map